import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';


import styles from './Version.css';



const actions = {};

/** Version component description */
class Version extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (<div className="Version">
                    <a href={`../v${process.env.REACT_APP_PREV_VERSION}`}>[prev]</a>
                    v {process.env.REACT_APP_VERSION}
                </div>);
    }
}

const mapStateToProps = (state, ownProps) => {
    return {}
    // return Object.assign({}, { z: state.xxx }, ownProps);
}

Version.displayName = "VersionComponent";
const connectedComponent = connect(
    mapStateToProps,
    {
        ...actions
    }
)(Version);
connectedComponent.displayName = "Version";


Version.propTypes = {

};

export default connectedComponent;
export { Version as VersionComponent };